(function(){
  const root = document.querySelector('[data-rlfa]');
  if(!root) return;

  const $ = (sel) => root.querySelector(sel);
  const els = {
    species: $('[data-rlfa-species]'),
    weight: $('[data-rlfa-weight]'),
    photo: $('[data-rlfa-photo]'),
    scale: $('[data-rlfa-scale]'),
    dropzone: $('[data-rlfa-dropzone]'),
    file: $('[data-rlfa-file]'),
    preview: $('[data-rlfa-preview]'),
    previewImg: $('[data-rlfa-preview-img]'),
    headLine: $('[data-rlfa-head-line]'),
    bodyLine: $('[data-rlfa-body-line]'),
    analyze: $('[data-rlfa-analyze]'),
    review: $('[data-rlfa-review]'),
    analyzing: $('[data-rlfa-analyzing]'),
    analyzingText: $('[data-rlfa-analyzing-text]'),
    progress: $('[data-rlfa-progress]'),
    resultBody: $('[data-rlfa-result-body]'),
    size: $('[data-rlfa-size]'),
    equivalent: $('[data-rlfa-equivalent]'),
    confidence: $('[data-rlfa-confidence]'),
    confidenceLabel: $('[data-rlfa-confidence-label]'),
    confidenceText: $('[data-rlfa-confidence-text]'),
    ring: $('[data-rlfa-ring]'),
    estWeight: $('[data-rlfa-est-weight]'),
    diameter: $('[data-rlfa-diameter]'),
    length: $('[data-rlfa-length]'),
    why: $('[data-rlfa-why]'),
    shop: $('[data-rlfa-shop]')
  };

  const sizes = [
    {max:1,name:'Micro',diameter:'1/4 in',length:'0.5–1 in',equiv:'Smaller than pinky mouse',url:'/collections/all'},
    {max:2,name:'Mini',diameter:'1/2 in',length:'1 in',equiv:'Large pinky mouse',url:'/collections/all'},
    {max:5,name:'Mini Plus / 5g',diameter:'0.4–1/2 in',length:'1–2 in',equiv:'Fuzzy mouse',url:'/collections/all'},
    {max:10,name:'10g',diameter:'3/4 in',length:'1.5 in',equiv:'Hopper mouse / Pinky rat',url:'/collections/all'},
    {max:18,name:'18g',diameter:'15/16 in',length:'2 in',equiv:'Weanling mouse / Fuzzie rat',url:'/collections/all'},
    {max:25,name:'25g',diameter:'15/16 in',length:'2.5–3 in',equiv:'Large adult mouse / Rat pup',url:'/collections/all'},
    {max:50,name:'50g Long',diameter:'15/16 in',length:'5–6 in',equiv:'Breeder mouse / Small rat',url:'/collections/all'},
    {max:75,name:'75g',diameter:'1.25 in',length:'4–5 in',equiv:'Small-medium rat',url:'/collections/all'},
    {max:99999,name:'100g',diameter:'1.25 in',length:'5–6 in',equiv:'Medium rat',url:'/collections/all'}
  ];

  function recommend(weight){
    if(!weight || weight <= 0) return sizes[5];
    const target = Math.max(weight * 0.08, 1); // MVP placeholder: approx 8% body weight meal.
    return sizes.find(s => target <= s.max) || sizes[sizes.length-1];
  }

  function setPreview(file){
    if(!file) return;
    els.file.textContent = 'Selected: ' + file.name;
    els.previewImg.src = URL.createObjectURL(file);
    els.preview.hidden = false;
    const isLizard = els.species && els.species.value === 'lizard';
    els.headLine.style.display = isLizard ? 'block' : 'none';
    els.bodyLine.style.display = isLizard ? 'none' : 'block';
  }

  if(els.photo){
    els.photo.addEventListener('change', () => setPreview(els.photo.files[0]));
  }

  if(els.species){
    els.species.addEventListener('change', () => {
      if(els.preview && !els.preview.hidden && els.photo.files[0]) setPreview(els.photo.files[0]);
    });
  }

  ['dragenter','dragover'].forEach(evt => {
    els.dropzone.addEventListener(evt, e => { e.preventDefault(); els.dropzone.classList.add('is-dragover'); });
  });
  ['dragleave','drop'].forEach(evt => {
    els.dropzone.addEventListener(evt, e => { e.preventDefault(); els.dropzone.classList.remove('is-dragover'); });
  });
  els.dropzone.addEventListener('drop', e => {
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    if(!file) return;
    const dt = new DataTransfer();
    dt.items.add(file);
    els.photo.files = dt.files;
    setPreview(file);
  });

  function runProgress(callback){
    const steps = ['Checking photo quality...','Looking for scale object...','Applying Reptilinks sizing chart...','Generating recommendation...'];
    els.resultBody.hidden = true;
    els.analyzing.hidden = false;
    els.progress.style.width = '0%';
    let i = 0;
    const timer = setInterval(() => {
      els.analyzingText.textContent = steps[Math.min(i, steps.length-1)];
      els.progress.style.width = Math.min(100, (i+1) * 25) + '%';
      i++;
      if(i >= steps.length){
        clearInterval(timer);
        setTimeout(() => { els.analyzing.hidden = true; els.resultBody.hidden = false; callback(); }, 350);
      }
    }, 450);
  }

  function updateResult(){
    const weight = Number(els.weight.value || 0);
    const result = recommend(weight);
    const hasPhoto = !!(els.photo.files && els.photo.files[0]);
    let confidence = 72;
    if(weight) confidence += 10;
    if(hasPhoto) confidence += 8;
    if(els.scale.checked) confidence += 8;
    confidence = Math.min(confidence, 98);

    root.classList.toggle('is-low-confidence', confidence < 90);
    els.size.textContent = result.name;
    els.equivalent.textContent = result.equiv;
    els.confidence.textContent = confidence + '%';
    els.ring.style.setProperty('--confidence', confidence);
    els.estWeight.textContent = weight ? weight + ' g' : 'Not provided';
    els.diameter.textContent = result.diameter;
    els.length.textContent = result.length;
    els.shop.href = result.url;

    if(confidence >= 90){
      els.confidenceLabel.textContent = 'High confidence';
      els.confidenceText.textContent = 'This result is ready to use.';
    } else {
      els.confidenceLabel.textContent = 'Expert review suggested';
      els.confidenceText.textContent = 'We recommend team review before purchase.';
    }

    const typeText = els.species.value === 'lizard' ? 'head width / eye spacing' : 'widest body point';
    els.why.textContent = `This MVP uses your reptile details and Reptilinks size chart. For this species type, the final AI version will compare product diameter to the ${typeText} shown in the uploaded photo.`;
    els.size.closest('.rlfa__result').scrollIntoView({behavior:'smooth', block:'center'});
  }

  els.analyze.addEventListener('click', () => runProgress(updateResult));
  els.review.addEventListener('click', () => {
    alert('Expert review placeholder. Next phase: this will send the uploaded photo, species, weight, and recommendation to your team.');
  });
})();
